/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import createTrack from 'services/actions/tracker_actions';
import {
  FILTROS_AMOSTRAS_VAZIOS,
  FiltrosAmostras,
  fmtInt,
  totalFiltrosAmostras,
} from 'services/price_intelligence';
import { Container } from './styles';

interface PriceIntelligenceRefineProps {
  filtros: FiltrosAmostras;
  onChange: (filtros: FiltrosAmostras) => void;
  total: number;
  filtradas: number;
}

interface CampoTexto {
  campo: keyof FiltrosAmostras;
  label: string;
  placeholder: string;
}

const CAMPOS: CampoTexto[] = [
  { campo: 'descricao', label: 'Descrição contém', placeholder: 'Termo exato na descrição' },
  { campo: 'orgao', label: 'Órgão público', placeholder: 'Nome do órgão' },
  { campo: 'municipio', label: 'Cidade', placeholder: 'Município' },
  { campo: 'fornecedor', label: 'Concorrente', placeholder: 'Nome ou CNPJ' },
  { campo: 'marca', label: 'Marca / fabricante', placeholder: 'Marca, fabricante ou modelo' },
];

const PriceIntelligenceRefine = ({
  filtros,
  onChange,
  total,
  filtradas,
}: PriceIntelligenceRefineProps) => {
  const ativos = totalFiltrosAmostras(filtros);
  const [aberto, setAberto] = useState<boolean>(ativos > 0);

  const alterar = (campo: keyof FiltrosAmostras, valor: string) =>
    onChange({ ...filtros, [campo]: valor });

  const abrir = () => {
    if (!aberto) createTrack('Análise de Preços - Abriu filtros avançados', {});
    setAberto(!aberto);
  };

  return (
    <Container className="d-print-none">
      <div className="refine-head">
        <button type="button" className="refine-toggle" onClick={abrir}>
          <i className="material-icons">tune</i>
          Filtros avançados
          {ativos > 0 && <span className="refine-badge">{ativos}</span>}
          <i className="material-icons chevron">{aberto ? 'expand_less' : 'expand_more'}</i>
        </button>
        <span className="refine-summary">
          {ativos > 0
            ? `${fmtInt(filtradas)} de ${fmtInt(total)} amostras atendem aos filtros`
            : 'Refine as amostras por órgão, cidade, concorrente, marca ou faixa de valor'}
        </span>
        {ativos > 0 && (
          <button
            type="button"
            className="btn btn-link btn-sm refine-clear"
            onClick={() => onChange(FILTROS_AMOSTRAS_VAZIOS)}
          >
            <i className="material-icons">close</i>
            Limpar filtros
          </button>
        )}
      </div>

      {aberto && (
        <div className="refine-grid">
          {CAMPOS.map((c) => (
            <div key={c.campo} className="refine-field">
              <label htmlFor={`pi-refine-${c.campo}`}>{c.label}</label>
              <input
                id={`pi-refine-${c.campo}`}
                type="text"
                className="form-control form-control-sm"
                placeholder={c.placeholder}
                value={filtros[c.campo]}
                onChange={(e) => alterar(c.campo, e.target.value)}
              />
            </div>
          ))}
          <div className="refine-field">
            <label htmlFor="pi-refine-valor-min">Valor unitário</label>
            <div className="refine-range">
              <input
                id="pi-refine-valor-min"
                type="number"
                step="0.01"
                min="0"
                className="form-control form-control-sm"
                placeholder="Mínimo"
                value={filtros.valorMin}
                onChange={(e) => alterar('valorMin', e.target.value)}
              />
              <span>a</span>
              <input
                type="number"
                step="0.01"
                min="0"
                className="form-control form-control-sm"
                placeholder="Máximo"
                aria-label="Valor unitário máximo"
                value={filtros.valorMax}
                onChange={(e) => alterar('valorMax', e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default PriceIntelligenceRefine;
